module.exports = __webpack_public_path__ + "img/sanvy-pro.78512fda.jpg";